import React, { useContext } from "react";
import { Button } from "@material-ui/core";
import { NavHashLink as NavLink } from "react-router-hash-link";
import { makeStyles } from "@material-ui/core/styles";

import "./Landing.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { headerData } from "../../data/headerData";
import { socialsData } from "../../data/socialsData";
// import img from "../../assets/svg/about/online-resume.svg";

import {
  //   FaTwitter,
  FaLinkedin,
  FaGithub,
  //   FaYoutube,
  //   FaBlogger,
  //   FaFacebook,
  FaInstagram,
  FaGitlab,
} from "react-icons/fa";

function Landing() {
  const { theme, drawerOpen } = useContext(ThemeContext);

  const useStyles = makeStyles((t) => ({
    resumeBtn: {
      color: theme?.white || theme.primary,
      borderRadius: "25px",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      fontSize: "1rem",
      fontWeight: "500",
      height: "50px",
      fontFamily: "var(--primaryFont)",
      border: `1px solid ${theme?.white || theme.primary}`,
      transition: "100ms ease-out",
      "&:hover": {
        color: theme.secondary,
        backgroundColor: theme.tertiary,
        border: `3px solid ${theme.tertiary}`,
      },
      [t.breakpoints.down("sm")]: {
        width: "180px",
      },
    },
    contactBtn: {
      backgroundColor: theme.primary,
      color: theme?.white || theme.secondary,
      borderRadius: "25px",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      height: "50px",
      fontSize: "1rem",
      fontWeight: "500",
      fontFamily: "var(--primaryFont)",
      border: `1px solid ${theme.primary}`,
      transition: "100ms ease-out",
      "&:hover": {
        color: theme.tertiary,
        backgroundColor: theme.secondary,
        border: `2px solid ${theme.tertiary}`,
      },
      [t.breakpoints.down("sm")]: {
        display: "none",
      },
    },
  }));

  const classes = useStyles();

  return (
    <div className="landing">
      <div className="landing--container">
        <div
          className="landing--container-left"
          style={{ backgroundColor: theme.primary }}
          // style={{ background: `url(${img})` }}
        >
          <div className="lcl--content">
            {socialsData.linkedIn && (
              <a href={socialsData.linkedIn} target="_blank" rel="noreferrer">
                <FaLinkedin
                  className="landing--social"
                  style={{ color: "#ffffff" }}
                />
              </a>
            )}
            {socialsData.linkedIn && (
              <a href={socialsData.instagram} target="_blank" rel="noreferrer">
                <FaInstagram
                  className="landing--social"
                  style={{ color: "#ffffff" }}
                />
              </a>
            )}
            {socialsData.github && (
              <a href={socialsData.github} target="_blank" rel="noreferrer">
                <FaGithub
                  className="landing--social"
                  style={{ color: "#ffffff" }}
                />
              </a>
            )}
            {/* {socialsData.twitter && (
                            <a href={socialsData.twitter} target="_blank" rel="noreferrer">
                                <FaTwitter className="landing--social" style={{color: theme.secondary}}/>
                            </a>
                        )} */}
            {/* {socialsData.youtube && (
                            <a href={socialsData.youtube} target="_blank" rel="noreferrer">
                                <FaYoutube className="landing--social" style={{color: theme.secondary}}/>
                            </a>
                        )} */}
            {/* {socialsData.blogger && (
                            <a href={socialsData.blogger} target="_blank" rel="noreferrer">
                                <FaBlogger className="landing--social" style={{color: theme.secondary}}/>
                            </a>
                        )}
                        {socialsData.facebook && (
                            <a href={socialsData.facebook} target="_blank" rel="noreferrer">
                                <FaFacebook className="landing--social" style={{color: theme.secondary}}/>
                            </a>
                        )} */}
            {socialsData.gitlab && (
              <a href={socialsData.gitlab} target="_blank" rel="noreferrer">
                <FaGitlab
                  className="landing--social"
                  style={{ color: "#ffffff" }}
                />
              </a>
            )}
          </div>
        </div>
        <img
          src={headerData.image}
          alt=""
          className="landing--img"
          style={{
            opacity: `${drawerOpen ? "0" : "1"}`,
            borderColor: theme.secondary,
          }}
        />
        <div
          className="landing--container-right"
          style={{ backgroundColor: theme.secondary }}
        >
          <div className="lcr--content" style={{ color: theme.tertiary }}>
            <h6>{headerData.title}</h6>
            <h1 style={{ color: theme.primary }}>{headerData.name}</h1>
            <p>{headerData.desciption}</p>

            <div className="lcr-buttonContainer">
              {headerData.resumePdf && (
                <a
                  href={headerData.resumePdfLink}
                  download="Bikash's Resume"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button className={classes.resumeBtn}>Request CV</Button>
                </a>
              )}
              <NavLink to="/#contacts" smooth={true} spy="true" duration={2000}>
                <Button className={classes.contactBtn}>Contact</Button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
